// ============================================
// 2D 组件联动事件执行器（阶段3｜3.3）
// 之前只有 EventForm 配置表单、无执行器；本模块补齐统一分发：
// dispatchWidgetEvents(comp, trigger) → 遍历 comp.events 匹配 trigger 执行 action。
// 动作：
//  - locate3dDevice      ：selectDevice(deviceId, {focus:true})  → 3D 定位+高亮+飞行（useDeviceLink3D 消费）
//  - highlight3dDevice   ：selectDevice(deviceId, {focus:false}) → 3D 高亮（不飞行）
//  - linkGlobalDevice    ：selectDevice(deviceId, {focus:false}) → 选中联动（设备详情/过滤）
//  - refresh             ：signalRefresh(targetId) → 目标组件重拉数据
//  - openUrl             ：新窗口打开
//  - filter/passParam/switchTab：历史动作仅配置无执行器，保留注册（no-op，待各自宿主能力跟进）
// ============================================

import type { VisualComponent } from '@dtwin/shared';
import useDashboardStore from '../stores/dashboardStore';
import { useDeviceDataStore } from '../stores/deviceDataStore';

export type WidgetActionHandler = (ev: any, comp: VisualComponent) => void;

const HANDLERS: Record<string, WidgetActionHandler> = {
  locate3dDevice: (ev) => {
    const deviceId = String(ev.deviceId ?? '').trim();
    if (!deviceId) return;
    useDeviceDataStore.getState().selectDevice(deviceId, { focus: true });
  },
  highlight3dDevice: (ev) => {
    const deviceId = String(ev.deviceId ?? '').trim();
    if (!deviceId) return;
    useDeviceDataStore.getState().selectDevice(deviceId, { focus: false });
  },
  linkGlobalDevice: (ev) => {
    const deviceId = String(ev.deviceId ?? '').trim();
    if (!deviceId) return;
    useDeviceDataStore.getState().selectDevice(deviceId, { focus: false });
  },
  refresh: (ev) => {
    if (ev.targetId) useDashboardStore.getState().signalRefresh(ev.targetId);
  },
  openUrl: (ev) => {
    if (ev.url) window.open(ev.url, '_blank', 'noopener');
  },
};

/** 触发组件交互：执行所有匹配 trigger 的事件动作 */
export function dispatchWidgetEvents(comp: VisualComponent | null | undefined, trigger: 'click' | 'hover') {
  if (!comp) return;
  const events = (comp.events as any[]) || [];
  for (const ev of events) {
    if (!ev || ev.trigger !== trigger) continue;
    const handler = HANDLERS[ev.action];
    if (handler) {
      try {
        handler(ev, comp);
      } catch (e) {
        console.warn(`[WidgetEvent] action ${ev.action} failed:`, e);
      }
    }
  }
}

/** 组件点击回调（宿主 wrapper 使用） */
export function makeWidgetClickHandler(comp: VisualComponent | null | undefined) {
  return () => dispatchWidgetEvents(comp, 'click');
}